module.exports = __webpack_public_path__ + "static/media/instagram.c49015b6.svg";